import { render, staticRenderFns } from "./setName.vue?vue&type=template&id=55f6f69a&"
import script from "./setName.vue?vue&type=script&lang=js&"
export * from "./setName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports